import { Button, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useMemo, useState } from "react";

import { Customer } from "../../types";
import { useSelector } from "react-redux";
import Table from "../Document-Management/table/DocumentManagementTable";
import AddDocumentModal from "./modal/AddDocumentModal";
import { getParsedLocalStorage } from "../../Utils/storage-utils";
import DocumentManagementFilters from "./filters/DocumentManagementFilters";
import { selectedCustomersSelector } from "../../features/authentication/auth-slice";
import { PCCLStorageDocumentManagementTableColumns } from "../../constants/document-management/DocumentManagementTableColumns";
import { DocumentManagementFiltersType } from "../../types/document-management/document-management-types";

import "../../styles/document-management.scss";
import document_management_apis, { GetPaginatedDocumentsParams } from "../../Services/document-management-apis";

const DEFAULT_FILTER_VALUES = {
  from_ts: null,
  end_ts: null,
  user_name: "",
  document_name: "",
  user_role: "",
  remarks: "",
  document_type: [],
  section: [],
  station: [],
  page: 0,
  pageSize: 20,
};

function getPaginatedDocumentsParams(filters: DocumentManagementFiltersType) {
  const params: GetPaginatedDocumentsParams = {
    limit: filters.pageSize,
    offset: filters.page * filters.pageSize,
    module: "PCCL_STORAGE",
  };
  if (filters.from_ts) params.from_ts = filters.from_ts.valueOf();
  if (filters.end_ts) params.to_ts = filters.end_ts.endOf("day").valueOf();
  if (filters.document_name) params.doc_name_contain = filters.document_name;
  if (filters.remarks) params.remark_contain = filters.remarks;
  if (filters.document_type.length > 0) params.doc_types = filters.document_type.toString();
  if (filters.section.length > 0) params.div_codes = filters.section.toString();
  if (filters.station) params.customer_ids = filters.station.map((customer) => customer.customerId).toString();
  // if (filters.station.length > 0)
  //   params.customer_ids = filters.station.map((customer) => customer.customerId).toString();

  return params;
}

// export const DocumentManagementWrapper = () => {
//   const { station } = useParams();

//   const stationMap: Record<string, Customer> = getParsedLocalStorage("stationMap");
//   //console.log("station map in DM", stationMap);

//   if (!station || !stationMap[station as keyof typeof stationMap]) {
//     return <PageNotFound />;
//   }
//   return <TypicalDrawingStorageContainer customer={stationMap[station as keyof typeof stationMap]} />;
// };

interface Props {
  customer?: Customer;
}
export const PCCLStorageContainer: React.FC<Props> = ({ customer }) => {
  const [filters, setFilters] = useState<DocumentManagementFiltersType>(DEFAULT_FILTER_VALUES);

  const selected_customers = useSelector(selectedCustomersSelector);

  const current_customers: Customer[] = useMemo(() => {
    if (!customer) {
      if (filters.station.length === 0) return selected_customers as Customer[];
      return filters.station;
    }
    return [customer];
  }, [customer, filters.station, selected_customers]);

  const { data: documents = { items: [], totalRecords: 0 }, isFetching } =
    document_management_apis.useGetPaginatedDocumentsQuery(
      getPaginatedDocumentsParams({ ...filters, station: current_customers ?? null }),
    );

  const [uploadPopupOpen, setUploadPopupOpen] = useState<boolean>(false);

  function handleFilterChange(value: DocumentManagementFiltersType) {
    setFilters((state) => ({
      ...state,
      ...value,
      page: 0,
    }));
  }

  function openUploadPopup() {
    setUploadPopupOpen(true);
  }

  function pageChange(index: number) {
    setFilters((state) => ({ ...state, page: index }));
  }

  function pageSizeChange(size: number) {
    setFilters((state) => ({ ...state, pageSize: size }));
  }

  return (
    <div className="document-management fullHeight flex flex-col">
      {/* Filters */}
      <Typography variant="h1" sx={{fontSize: 24, fontWeight: "bold", marginBottom: 2}}>Pre-commisioning Check List(PCCL) Storage</Typography>
      <DocumentManagementFilters handleFilterChange={handleFilterChange} />

      <div className="flex justify-end">
        <Button variant="outlined" className="add-new-document--button" onClick={openUploadPopup}>
          Add New
        </Button>
      </div>

      <Table
        rows={documents?.items || []}
        columns={PCCLStorageDocumentManagementTableColumns}
        loading={isFetching}
        rowCount={documents?.totalRecords}
        page={filters.page}
        pageSize={filters.pageSize}
        pageChange={pageChange}
        pageSizeChange={pageSizeChange}
      />

      {/* Upload Documents Popup */}
      {uploadPopupOpen && <AddDocumentModal handleClose={() => setUploadPopupOpen(false)} customer={customer} />}
    </div>
  );
};
export default PCCLStorageContainer;
